export default "__VITE_ASSET__BIU4mcO0__"